import { unwrapResponse } from "../../../../response.js";
import { postJson, acceptJson } from "../../../../shared.js";
async function resetPassword(apiUrl, request) {
  return unwrapResponse(
    await fetch(`${apiUrl}/customers/account/password/reset`, {
      method: "POST",
      headers: {
        ...acceptJson,
        ...postJson
      },
      body: JSON.stringify(request)
    })
  );
}
export {
  resetPassword
};
//# sourceMappingURL=reset.js.map
